module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm3_en.596f5d15c24f5cf37e58e388fb0c8b43.png";